import React from 'react';
import history from './router/history';
import Router from './router/Router';

import GDPRpopup from './components/GDPRpopup';

import './App.scss';

export class App extends React.PureComponent {
  render() {
    return (
      <div className="App">
        <Router history={history} />
        <GDPRpopup />
      </div>
    );
  }
}

export default App;
